import React, { 
  //useState 
} from 'react';

import { generateBackground, sanitizeHtmlContent } from '../utils/utils'
import UtilImage from '../utils/util-image'

import {
  //Segment,
  Card,
  //Icon,
  Button,
} from 'semantic-ui-react';

export default function ContentCard(props) {
  //console.log('ContentCard - props', props);

  const {
    parentProps,
    displayText,
    variationType,
    textColor,
    backgroundColor,
    contentText,
    content2,
    contentDescription,
    content3,
    image,
    imageSize,
    icon,
    externalLink,
    imageAsBackground,
  } = props;

  const sectionBackground = generateBackground(backgroundColor ? backgroundColor : parentProps && parentProps.backgroundColor ? parentProps.backgroundColor : null, null);

  //get variation type from Card or Card.Group props
  const selectedVariationType = variationType ? variationType : parentProps && parentProps.variationType ? parentProps.variationType : null;
  //get imageAsBackground from Card or Card.Group props
  const selectedImageAsBackground = parentProps && parentProps.imageAsBackground ? parentProps.imageAsBackground : imageAsBackground ? imageAsBackground : null;

  let toggleImageAsBackground = null;
  let cardImageAsBackground = null;
  if (selectedImageAsBackground !== null) {
    toggleImageAsBackground = selectedImageAsBackground.toggleImageAsBackground;
    if (toggleImageAsBackground) {
      cardImageAsBackground = generateBackground(backgroundColor ? backgroundColor : parentProps && parentProps.backgroundColor ? parentProps.backgroundColor : null, image)
    }
  }
  //console.debug('test', {selectedImageAsBackground, cardImageAsBackground});
  
  return (
    <>
      {selectedVariationType === 'simple' ?
        <Card className={'site-content-card '+selectedVariationType+' '+(toggleImageAsBackground ? 'image-as-background' : null)} style={{ color: textColor ? textColor : parentProps && parentProps.textColor ? parentProps.textColor : null, background: sectionBackground, }}
          href={externalLink?.url ? externalLink.url : null}
          target={externalLink?.url ? '_blank' : null}
          rel={externalLink?.url ? 'noreferrer' : null}
        >
          {!toggleImageAsBackground && image && image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 ?
            <UtilImage imageType={'card'} altText={(displayText ? displayText : '') +' image'} image={image} imageSize={imageSize} />
          :
            null
          }
          {toggleImageAsBackground && image && image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 && cardImageAsBackground ?
            <div className={'fluid image'} style={{ background: cardImageAsBackground, backgroundSize: 'contain', backgroundPosition: 'center center' }}></div>
          :
            null
          }
          {contentText || content2 || contentDescription ?
            <Card.Content>
              {contentText ?
                <Card.Header>
                  {contentText}
                </Card.Header>
              :
                null
              }
              {content2 ?
                <Card.Description>
                  {content2}
                </Card.Description>
              :
                null
              }
              {contentDescription && contentDescription.html ?
                <Card.Description>
                  <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(contentDescription.html, {allowedTags: false, allowedAttributes: false, allowVulnerableTags: true})}}></div>
                </Card.Description>
              :
                null
              }
            </Card.Content>
          :
            null
          }
          {content3 ?
            <Card.Content extra>
              {content3}
            </Card.Content>
          :
            null
          }
        </Card>
      : selectedVariationType === 'team-card' ?
        <Card className={'site-content-card '+selectedVariationType} style={{ color: textColor ? textColor : parentProps && parentProps.textColor ? parentProps.textColor : null, }}>
          {image && image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 ?
            <div className={'image-wrapper'} style={{ background: sectionBackground, }}>
              {(icon && icon.iconName) || (parentProps && parentProps.icon && parentProps.icon.iconName) ?
                <Button primary size={'large'} as={'a'} href={externalLink.url ? externalLink.url : '#'} target={'_blank'} icon={icon && icon.iconName !== null ? icon.iconName : parentProps && parentProps.icon && parentProps.icon.iconName !== null ? parentProps.icon.iconName : null} />
              :
                null
              }
              <UtilImage imageType={'card'} altText={(displayText ? displayText : '') +' image'} image={image} imageSize={imageSize} />
            </div>
          :
            null
          }
          <Card.Content>
            <Card.Header>
              {contentText}
            </Card.Header>
            <Card.Description>
              {content2}
            </Card.Description>
          </Card.Content>
        </Card>
      :
        <Card className={'site-content-card '+selectedVariationType+' '+(toggleImageAsBackground ? 'image-as-background' : null)} 
          style={{ color: textColor ? textColor : parentProps && parentProps.textColor ? parentProps.textColor : null, background: sectionBackground, }}
          href={externalLink?.url ? externalLink.url : null}
          target={externalLink?.url ? '_blank' : null}
          rel={externalLink?.url ? 'noreferrer' : null}
        >
          {!toggleImageAsBackground && image && image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 ?
            <UtilImage imageType={'card'} altText={(displayText ? displayText : '') +' image'} image={image} imageSize={imageSize} />
          :
            null
          }
          {toggleImageAsBackground && image && image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0 && cardImageAsBackground ?
            <div className={'fluid image'} style={{ background: cardImageAsBackground, backgroundSize: 'contain', backgroundPosition: 'center center' }}></div>
          :
            null
          }
          {contentText || content2 || contentDescription ?
            <Card.Content>
              {contentText ?
                <Card.Header>
                  {contentText}
                </Card.Header>
              :
                null
              }
              {content2 ?
                <Card.Description>
                  {content2}
                </Card.Description>
              :
                null
              }
              {contentDescription && contentDescription.html ?
                <Card.Description>
                  <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(contentDescription.html, {allowedTags: false, allowedAttributes: false, allowVulnerableTags: true})}}></div>
                </Card.Description>
              :
                null
              }
            </Card.Content>
          :
            null
          }
          {content3 ?
            <Card.Content extra>
              {content3}
            </Card.Content>
          :
            null
          }
        </Card>
      }
    </>
  )
}
